import React, {Component} from 'react';
import Header from "../Header";
import Menu from "../Menu";

class NavigationAuth extends Component {

    constructor(props) {
        super(props);
        this.state = { user : this.props.user}

    }

    render() {
        return (
            <div>
                <Header/>
                <Menu user={this.props.user} removeUser={ this.props.removeUser} returnToIndex={ this.props.returnToIndex} />
            </div>
        );
    }
}

export default NavigationAuth;